import React from 'react';
import styled from 'styled-components';
import { imageBoxStyles } from './Styles';

export const Box = styled.div`
  ${imageBoxStyles}
`;

export default function Image({ mediaSrc, className }) {
  return (
    <Box className={className}>
      <img src={mediaSrc} alt="" />
    </Box>
  );
}
